import { DesktopWizardProps } from '../../Types'
import { DesktopWizard } from '../../DesktopWizard/DesktopWizard'
import { ImageSelection } from '../Steps/ImageSelection/ImageSelection'
import { BackgroundRemoval } from '../Steps/BackgroundRemoval/BackgroundRemoval'
import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { TemplateStepWrapper } from './TemplateStepWrapper'

export const FlowB = observer((props: DesktopWizardProps) => {
  const { initialValues } = props
  const startWithTemplate = initialValues?.startWithTemplate
  const source_visual_element_id = initialValues?.source_visual_element_id
  const { visualElements } = useRootStore()

  const initialTemplate = useMemo(
    () =>
      source_visual_element_id && startWithTemplate ? visualElements.getElement(source_visual_element_id) : undefined,
    [], // eslint-disable-line react-hooks/exhaustive-deps
  )
  const initialTemplateWithoutImage = startWithTemplate && !initialTemplate?.has_replaceable

  if (initialTemplateWithoutImage)
    return (
      <DesktopWizard
        {...props}
        schema={{
          ...props.schema,
          steps: [props.schema.steps[2]],
        }}
      >
        <TemplateStepWrapper templateName={initialTemplate?.name} templateFieldDescription="" />
      </DesktopWizard>
    )

  return (
    <DesktopWizard {...props} schema={props.schema}>
      <ImageSelection />
      <BackgroundRemoval initialRemoveBackground={false} />
      <TemplateStepWrapper templateFieldDescription="Suggestions are based on the selected image" />
    </DesktopWizard>
  )
})
